import React, { useState } from "react";
import styles from "./Slider.module.scss"; // You can create a separate CSS file for styling

interface Slide {
  title: string;
  text: string;
}

const slides: Slide[] = [
  {
    title: "Stay in Control",
    text: "View all your funded loans in one place",
  },
  {
    title: "Instantly check the DMV title status of vehicles",
    text: "Quick and Easy Access",
  },
  {
    title: "All Your Customers, All in One Place",
    text: "Access detailed customer profiles",
  },
  {
    title: "Resolve Issues Efficiently",
    text: "Create and manage support tickets for your loans",
  },
];

const Slider = ({ className }: { className?: string }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleSlideClick = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className={`${styles.sliderContainer} ${className}`}>
      <div className={styles.sliderInfo}>
        <h2 className={styles.title}>{slides[currentSlide].title}</h2>
        <p className={styles.text}>{slides[currentSlide].text}</p>
      </div>
      <div className={styles.slides}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`
              ${styles.slide} ${
              currentSlide === index ? styles.active : styles.inactive
            }`}
            onClick={() => handleSlideClick(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;
